var _linearGradient, _linearGradient2, _path, _ellipse, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _path8, _path9, _path0, _path1, _path10, _ellipse2, _path11, _path12, _path13, _path14, _g, _path15, _path16, _g2, _path17, _path18;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupportSoftwareManualsIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 84,
    viewBox: "0 0 131.803 84",
    width: 131.803,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "support_software_manuals_icon_svg__a",
    gradientUnits: "objectBoundingBox",
    x2: 0.84,
    y1: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3a3eef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12b9d9"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "support_software_manuals_icon_svg__b",
    x2: 1,
    xlinkHref: "#support_software_manuals_icon_svg__a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m146.532 107.121 4.985 6.8a52.024 52.024 0 0 1 9.217 5.375l-1.189 1.856s-8.2-3.357-10.3-4.776l-3.831-6.006 1.115-3.254z",
    fill: "#a0616a",
    transform: "translate(-118.564 -87.34)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.527,
    cy: 2.571,
    fill: "#a0616a",
    rx: 1.527,
    ry: 2.571,
    transform: "matrix(.56420351 -.82563575 .82563575 .56420351 40.044 33.617)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m2.284 30.356-1.436-2.834s.239-3.464.553-7.694l-1.1.078s.106-.657-.186-.845.018-.192.269-.463-.009-.26-.28-.511 1.296-11.142 1.517-12.194a1.829 1.829 0 0 1 1.126-1.347l.365-.013c.874-.518 3.088-2.055 3.088-2.055l1.561-2.478 3.523.261 1.173 1.956a8.281 8.281 0 0 1 2.408 1.633 1.837 1.837 0 0 1 .776.743c.536.932 4.329 9.249 4.149 9.571s-.431.393-.109.573.617.089.4.358.085.861.085.861l-4.135 3.044c.055 4.148.078 7.6.078 7.6l1.956 2.87-.13 2.479-15.652.782z",
    fill: "url(#support_software_manuals_icon_svg__a)",
    transform: "translate(13.007 9.852)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m103.986 412.074h1.99l.947-7.677h-2.937z",
    fill: "#a0616a",
    transform: "translate(-84.783 -329.719)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m108.773 435.81a1.709 1.709 0 0 1 .095.563.675.675 0 0 1 -.675.675h-6.163a.461.461 0 0 1 -.461-.461v-.257a1.97 1.97 0 0 1 .323-1.722s.78.744 1.946-.421l.344-.623 2.489 1.82 1.379.17c.3.037.569-.006.725.256z",
    fill: "#2f2e41",
    transform: "translate(-82.752 -353.5)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m142.995 402.04 1.963.329 2.205-7.414-2.9-.486z",
    fill: "#a0616a",
    transform: "translate(-116.589 -321.625)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m147.48 428.206a1.709 1.709 0 0 1 0 .57.675.675 0 0 1 -.778.554l-6.078-1.021a.461.461 0 0 1 -.378-.531l.043-.253a1.97 1.97 0 0 1 .6-1.644s.646.863 1.989-.093l.442-.557 2.153 2.207 1.332.4c.291.087.562.089.672.372z",
    fill: "#2f2e41",
    transform: "translate(-114.342 -346.705)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m98.108 222.162s2.674 3.13 2.674 6 .065 11.884.065 11.884-1.565 14.073-1.957 15.247a18.458 18.458 0 0 0 -.587 3.13l-3.783-.913s-.52-13.239 1.045-16.37l-3.783-10.7-1.3 30.261h-4.396s-2.261-15.909-1.086-20.083c0 0-2.609-15.913-1.957-16.826s15.065-1.63 15.065-1.63z",
    fill: "#2f2e41",
    transform: "translate(-67.622 -181.136)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.362,
    cy: 4.931,
    fill: "#a0616a",
    r: 4.435
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m100.275 1.713a1.559 1.559 0 0 0 -1.53-1.013h-.086a6.4 6.4 0 0 1 -1-.2 3.61 3.61 0 0 0 -1.885.122 1.8 1.8 0 0 1 -.574.146.463.463 0 0 1 -.462-.3l-.038.521-.194-.422-.129.561-.414-.469a.6.6 0 0 1 -.247.547 2.274 2.274 0 0 1 -.558.288 3.074 3.074 0 0 0 -1.858 1.86 4.22 4.22 0 0 0 .008 1.706 3.573 3.573 0 0 0 .421 1.447 4.181 4.181 0 0 1 .533.811 6.071 6.071 0 0 0 .2.881 1.243 1.243 0 0 0 .72.523 3.247 3.247 0 0 1 .837.352c.247.178.533.69 1.07.663l.173-.326c.178-.145-.482-.03-.488-.26s.794-.372.681-.572c-.174-.307-.41-.574-.606-.867a1.592 1.592 0 0 1 -.331-1.162.845.845 0 0 1 .223-.435c.335-.341.708-.191 1.07-.142a.668.668 0 0 0 .678-.221c.152-.253-.017-.575 0-.869a1.065 1.065 0 0 1 .515-.745 7.074 7.074 0 0 0 .78-.517.828.828 0 0 0 .3-.835 2.806 2.806 0 0 1 2.418-.221 5.855 5.855 0 0 0 -.23-.85z",
    fill: "#2f2e41",
    transform: "translate(-74.37 -.349)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m38.894 248.407v-13.461a1.3 1.3 0 0 1 1.441-1.3 17.8 17.8 0 0 1 9.51 1 .6.6 0 0 1 .6.6v13.508a.6.6 0 0 1 -.6.6 25.825 25.825 0 0 0 -10.006 0 .947.947 0 0 1 -.945-.946z",
    fill: "#e6e6e6",
    transform: "translate(-31.712 -190.322)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m38.894 252.389v-13.6a1.306 1.306 0 0 1 1.3-1.3 18.525 18.525 0 0 1 9.647 0 .6.6 0 0 1 .6.6v13.37a.6.6 0 0 1 -.6.6 19.3 19.3 0 0 0 -10.007 1.29.947.947 0 0 1 -.945-.945z",
    fill: "#f2f2f2",
    transform: "translate(-31.712 -193.106)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m57.394 253.25h-3.042a1.981 1.981 0 1 1 0-3.963h3.042a1.981 1.981 0 1 1 0 3.963z",
    fill: "#e6e6e6",
    transform: "translate(-42.7 -203.252)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m78.728 126.057-.116 7.023s-.372 5.473-1.295 11.633l-2.2.14s.271-9.618.172-12.148l.156-5.621z",
    fill: "#a0616a",
    transform: "translate(-61.246 -102.779)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.527,
    cy: 2.571,
    fill: "#a0616a",
    rx: 1.527,
    ry: 2.571,
    transform: "matrix(.999 -.034 .034 .999 13.479 41.2)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m325.9 77.084h-45.086a2.552 2.552 0 0 1 -.77-.119l-.027-.011c-14.118-7.016-26.222-10.845-37-11.707l-.041-.008a2.544 2.544 0 0 1 -1.783-2.434v-60.249a2.553 2.553 0 0 1 3.32-2.435l35.643 11.274a2.181 2.181 0 0 0 .659.1h45.085a2.556 2.556 0 0 1 2.553 2.553v60.483a2.556 2.556 0 0 1 -2.553 2.553zm-45.732-.467a2.186 2.186 0 0 0 .645.1h45.087a2.186 2.186 0 0 0 2.184-2.184v-60.483a2.186 2.186 0 0 0 -2.184-2.184h-45.086a2.551 2.551 0 0 1 -.77-.119l-35.644-11.274a2.184 2.184 0 0 0 -2.842 2.082v60.25a2.176 2.176 0 0 0 1.506 2.076c10.821.869 22.959 4.708 37.1 11.736z",
    fill: "#3f3d56",
    transform: "translate(-196.65)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m292.068 81.407c12.293-4.35 26.007-3.851 40.577-.434a2.91 2.91 0 0 0 3.583-2.827v-55.051a2.905 2.905 0 0 0 -2.21-2.823c-15.369-3.758-29.725-4.45-42.377.016a2.921 2.921 0 0 1 -2.738-.445c-10.661-8.115-21.572-12.184-32.808-10.976a2.9 2.9 0 0 0 -2.579 2.889v55.651a2.907 2.907 0 0 0 2.61 2.89 85.56 85.56 0 0 1 33.543 10.908 2.9 2.9 0 0 0 2.4.2z",
    fill: "#f2f2f2",
    transform: "translate(-206.7 -7.058)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m307.094 91.438a4.516 4.516 0 0 1 -2.388-.681 62.551 62.551 0 0 0 -28.106-9.357 4.574 4.574 0 0 1 -4.169-4.539v-47.539a4.531 4.531 0 0 1 4.308-4.551c7.259-.338 16.074 2.9 27.738 10.184a4.19 4.19 0 0 0 3.292.5c11.085-2.976 23.1-3.062 36.736-.266a4.581 4.581 0 0 1 3.653 4.467v46.4a4.562 4.562 0 0 1 -5.633 4.427c-12.9-3.07-23.974-2.848-33.86.679a4.664 4.664 0 0 1 -1.568.274zm-29.32-66.322c-.344 0-.683.008-1.019.023a4.162 4.162 0 0 0 -3.955 4.182v47.536a4.2 4.2 0 0 0 3.83 4.171 62.92 62.92 0 0 1 28.27 9.415 4.189 4.189 0 0 0 3.638.374l.062.174-.062-.174c9.955-3.552 21.1-3.777 34.07-.69a4.192 4.192 0 0 0 5.178-4.068v-46.4a4.211 4.211 0 0 0 -3.358-4.106c-13.577-2.785-25.537-2.7-36.566.261a4.56 4.56 0 0 1 -3.583-.546c-11.054-6.9-19.518-10.152-26.506-10.152z",
    fill: "#fff",
    transform: "translate(-222.122 -20.177)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h.369v55.619h-.369z",
    fill: "#fff",
    transform: "matrix(1 -.009 .009 1 83.765 15.56)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3f3d56"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h.369v27.238h-.369z",
    transform: "matrix(.314 -.949 .949 .314 53.793 12.237)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h.369v27.238h-.369z",
    transform: "matrix(.314 -.949 .949 .314 53.793 19.082)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h.369v27.238h-.369z",
    transform: "matrix(.314 -.949 .949 .314 53.793 25.927)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h.369v27.238h-.369z",
    transform: "matrix(.314 -.949 .949 .314 53.793 32.772)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.358 20.814h30.993v.369h-30.993z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.358 27.278h30.993v.369h-30.993z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.358 33.743h30.993v.369h-30.993z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.358 40.208h30.993v.369h-30.993z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.358 46.673h30.993v.369h-30.993z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.358 53.137h30.993v.369h-30.993z"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m10.02 369.526a.419.419 0 0 1 -.3-.726l.029-.114-.011-.027a1.125 1.125 0 0 0 -2.076.008 9.994 9.994 0 0 0 -.878 2.5 3.329 3.329 0 0 0 .058 1.145 13.348 13.348 0 0 1 -1.214-5.544 12.883 12.883 0 0 1 .08-1.437q.066-.587.184-1.165a13.5 13.5 0 0 1 2.678-5.723 3.594 3.594 0 0 0 1.494-1.551 2.741 2.741 0 0 0 .249-.749 3.383 3.383 0 0 1 -.219-1.166c-.1-.154-.283-.23-.394-.38-.551-.747-1.309-.616-1.706.4-.846.427-.854 1.135-.335 1.817.33.433.376 1.02.666 1.484l-.091.113a13.59 13.59 0 0 0 -1.418 2.247 5.649 5.649 0 0 0 -.337-2.624 9.461 9.461 0 0 0 -1.461-2.108 1.16 1.16 0 0 0 -2.065.569v.03q.119.067.232.142a.568.568 0 0 1 -.229 1.034h-.012a5.657 5.657 0 0 0 .149.846c-.684 2.644.792 3.607 2.9 3.65l.138.07a13.871 13.871 0 0 0 -.747 3.514 13.156 13.156 0 0 0 .01 2.124v-.025a3.476 3.476 0 0 0 -1.194-2.007 26.124 26.124 0 0 0 -3.189-1.63.652.652 0 0 0 -1 .635v.026a3.809 3.809 0 0 1 .428.206q.119.067.232.142a.568.568 0 0 1 -.229 1.034h-.012-.024a5.661 5.661 0 0 0 1.041 1.63c.427 2.308 2.263 2.527 4.227 1.855a13.867 13.867 0 0 0 .932 2.719h3.33c.012-.037.023-.075.033-.112a3.781 3.781 0 0 1 -.921-.055l.741-.911.016-.018.377-.464a5.539 5.539 0 0 0 -.162-1.411z",
    fill: "#f2f2f2",
    transform: "translate(0 -288.727)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m47.353 452.718a.219.219 0 0 1 -.22.22h-46.773a.22.22 0 0 1 0-.44h46.774a.219.219 0 0 1 .22.22z",
    fill: "#ccc",
    transform: "translate(-.114 -368.938)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(118.405 63.604)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.247,
    cy: 4.247,
    fill: "url(#support_software_manuals_icon_svg__b)",
    r: 4.247
  }), /*#__PURE__*/React.createElement("path", {
    d: "m657.8 359.733-2.635-1.522a.185.185 0 0 0 -.277.16v1.337h-.791a.185.185 0 1 0 0 .369h.791v1.337a.185.185 0 0 0 .277.16l2.635-1.522a.185.185 0 0 0 0-.319z",
    fill: "#fff",
    transform: "translate(-651.561 -355.645)"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m336.664 267.068a8.951 8.951 0 0 1 2.209-5.124 8.828 8.828 0 0 1 7.779-2.837c.244.035.238.423-.009.388a8.554 8.554 0 0 0 -5.095.857 8.442 8.442 0 0 0 -4.5 6.725c-.022.248-.409.24-.388-.009z",
    fill: "#fff",
    transform: "translate(-274.493 -211.19)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m387.114 250.96 2.985 1.473a.2.2 0 0 1 .034.307l-2.825 2.336c-.191.158-.46-.121-.268-.281l2.826-2.336.034.307-2.985-1.473c-.224-.111-.023-.442.2-.333z",
    fill: "#fff",
    transform: "translate(-315.385 -204.599)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportSoftwareManualsIcon);
export default __webpack_public_path__ + "static/media/support_software_manuals_icon.4a5d4fea9e49688f808a11975aff1fbe.svg";
export { ForwardRef as ReactComponent };